import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUploadDriverPolygonIdActions from "../../store/actions/BulkUploadDriverPolygonId";
import BulkUploadFile from "../BulkUploadFile";

//change
const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  "Provide driver_id as id of driver.",
  "Provide polygon_id of polygon.",
  "Provide action as either 'ADD' or 'REMOVE'.",
  "Please refrain from putting anything else in columns other then the three (driver_id, polygon_id, action), as it may effect the processing of the file and can result in failures.",
];

const FileUploadModal = ({ getUploadUrl }) => {

  return (
    <BulkUploadDriverPolygonIdModal>
       <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BulkUploadPolygonIdActionsUpload"
        uploadUrl="/driver-polygon/id-bulk-upload/ack"
        sampleURL="/sample/bulk_upload_driver_polygon_id.csv"
        id="bulkUploadDriverPolygonIdModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Upload Driver Polygon Id"
        useUserUploadedFilename={true}
        getUploadUrl={getUploadUrl}
        validationType="BulkUploadDriverPolygonId"
        maxSize={0.5} // in mb
      />
    </BulkUploadDriverPolygonIdModal>
  );
};

const BulkUploadDriverPolygonIdModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkUploadDriverPolygonIdActions.bulkUploadDriverPolygonId,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);